import React from 'react';
import { Outlet } from 'react-router-dom';

export function CommunityHome(props) {
  return <Outlet />;
}
